module.exports = __webpack_public_path__ + "img/助力零售.2305db7e.png";